import BaseChart from './base-chart';
import { service } from '@ember/service';
import Formulas from '../../utils/formulas';

import $ from 'jquery';

export default class DriverPerformanceChart extends BaseChart {
    @service tabService;
    @service componentManager;
    @service errorHandling;
    @service('data') model;
    @service toolData;
    @service intl;

    didRender() {
        super.didRender();
        this.draw();
    }

    draw() {
        let model = this.model;

        if (this.errorHandling.tabError || model.driverPerformanceData.tempABError) return;

        let selfRef = this,
            colors = this.toolData.data.colors;

        let frequency = model.driverPerformanceData.abFrequencyArray,
            phase = model.driverPerformanceData.abPhaseArray,
            magnitude = model.driverPerformanceData.abMagnitudeArray,
            magnitudeLine = [],
            phaseLine = [];

        // xaxis
        let fLen = frequency.length,
            frequencyStart = 1000,
            frequencyEnd = Formulas.getDecade(model.selectedDriver.unityGain),
            frequencyAxisValues = this.setLogTicks(frequencyStart, frequencyEnd);

        // Find the first index that is plotted.
        let startIndex = 0;
        for (startIndex; startIndex < fLen; startIndex++) if (frequency[startIndex] >= frequencyStart) break;

        // yaxis left
        let magnitudeStart = 0.1,
            magnitudeEnd = Formulas.getDecade(magnitude[startIndex]),
            magnitudeAxisValues = this.setLogTicks(magnitudeStart, magnitudeEnd);

        for (let i = 0; i < fLen; i++) {
            // Do not add points to the line that will not be shown.
            if (frequency[i] < frequencyStart) continue;
            else if (frequency[i] > frequencyEnd) break;

            magnitudeLine.push([frequency[i], magnitude[i]]);
            phaseLine.push([frequency[i], phase[i]]);
        }

        // Find frequency where mangnitude is 1
        let mLLen = magnitudeLine.length,
            magnitudeMarker = 1,
            fDiff = Math.abs(magnitudeMarker - magnitudeLine[0][1]),
            freqAtMag1 = 0;

        for (let i = 1; i < mLLen; i++) {
            let newFDiff = Math.abs(magnitudeMarker - magnitudeLine[i][1]);

            if (newFDiff < fDiff) {
                fDiff = newFDiff;
                freqAtMag1 = magnitudeLine[i][0];
            }
        }

        // Create vertical and horizontal line for freqAtMag1.
        let verticalLine = [
                [freqAtMag1, magnitudeStart],
                [freqAtMag1, magnitudeEnd],
            ],
            horizontalLine = [
                [frequencyStart, magnitudeMarker],
                [freqAtMag1, magnitudeMarker],
            ];

        // Find the phase at the freqAtMag1.
        let pLLen = phaseLine.length,
            phaseAtFreq = 0;

        for (let i = 1; i < pLLen; i++) {
            if (phaseLine[i][0] === freqAtMag1) {
                phaseAtFreq = phaseLine[i][1];
                break;
            }
        }

        // Create horizontal line for phaseAtFreq.
        let horizontalLine2 = [
            [freqAtMag1, phaseAtFreq],
            [frequencyEnd, phaseAtFreq],
        ];

        // Clear the plot.
        let $currentPlot = $('#' + this.chartId);
        if ($currentPlot) $currentPlot.empty();

        window.jQuery.jqplot(this.chartId, [magnitudeLine, phaseLine, verticalLine, horizontalLine, horizontalLine2], {
            title: 'A * β',
            axesDefaults: {
                syncTicks: false,
                labelRenderer: window.jQuery.jqplot.CanvasAxisLabelRenderer,
                tickOptions: {
                    showGridline: false,
                    formatter: selfRef.prettyTickFormatter,
                    alignTicks: true,
                },
            },
            seriesDefaults: {
                showMarker: false,
                shadow: false,
                disableStack: false,
                rendererOptions: {
                    smooth: true,
                },
            },
            highlighter: {
                show: true,
                useAxesFormatters: true,
            },
            axes: {
                xaxis: {
                    renderer: window.jQuery.jqplot.LogAxisRenderer,
                    min: frequencyStart,
                    max: frequencyEnd,
                    label: selfRef.intl.t('chart_labels.frequency'),
                    rendererOptions: {
                        base: 10,
                    },
                    ticks: frequencyAxisValues,
                    pad: 0,
                },
                yaxis: {
                    label: 'Magnitude',
                    renderer: window.jQuery.jqplot.LogAxisRenderer,
                    rendererOptions: {
                        base: 10,
                    },
                    ticks: magnitudeAxisValues,
                    pad: 0,
                },
                y2axis: {
                    label: 'Phase',
                    min: -180,
                },
            },
            series: [
                {
                    xaxis: 'xaxis',
                    yaxis: 'yaxis',
                },
                {
                    xaxis: 'xaxis',
                    yaxis: 'y2axis',
                },
                {
                    lineWidth: 2,
                    linePattern: 'dashed',
                    xaxis: 'xaxis',
                    yaxis: 'yaxis',
                },
                {
                    lineWidth: 2,
                    linePattern: 'dashed',
                    xaxis: 'xaxis',
                    yaxis: 'yaxis',
                },
                {
                    lineWidth: 2,
                    linePattern: 'dashed',
                    xaxis: 'xaxis',
                    yaxis: 'y2axis',
                },
            ],
            cursor: {
                show: true,
                showTooltip: true,
            },
            grid: {
                borderColor: '#E5E5E5',
                shadow: false,
                background: '#FFFFFF',
            },
            legend: {
                show: true,
                location: 'sw',
                placement: 'insideGrid',
                labels: ['Magnitude', 'Phase'],
            },
            seriesColors: [colors.noiseSource, colors.noiseDriver, '#D9D9D9', '#D9D9D9', '#D9D9D9'],
        });

        // Removes all of the 'Series' lines from the legend.
        this.trimLegend();
    }
}
